export default __webpack_public_path__ + "static/media/change_password.10a7645f.svg";